import React, { useEffect, useState } from 'react';

import withForbiddenWithoutBuyingPackage from 'hocs/withForbiddenWithoutBuyingPackage';
import BootstrapTable from 'react-bootstrap-table-next';
import { Card, CardBody } from 'reactstrap';

import { buildExpandRow } from 'components/AnotherTable/expandableRow';

import AccrualsPageFilter from '../AccrualsPageFilter';
import PaginationComponent from '../PaginationComponent';

const DepositAccruals = ({
  items,
  totalPages,
  columns,
  displayedKeyNames,
  isPassiveAccruals,
  setIsPassiveAccruals,
  setFilter,
  filter,
  accrualsType,
  setSort,
}) => {
  const handleTableChange = (type, { sortField, sortOrder }) => {
    if (type === 'sort') {
      setSort({ field: sortField, order: sortOrder.toUpperCase() });
    }
  };

  return (
    <Card>
      <CardBody>
        <AccrualsPageFilter
          setIsPassiveAccruals={setIsPassiveAccruals}
          accrualsType={accrualsType}
          isPassiveAccruals={isPassiveAccruals}
          setFilter={setFilter}
          items={items}
          displayedKeyNames={displayedKeyNames}
          setSort={setSort}
        />
        <BootstrapTable
          keyField="id"
          data={items}
          columns={columns}
          headerClasses="table-head"
          wrapperClasses="table-responsive"
          classes="table__adaptive_bordered_between text-center mc-expandable"
          responsive
          remote
          expandRow={buildExpandRow(columns)}
          onTableChange={handleTableChange}
        />
        <PaginationComponent
          active={filter?.pageNumber}
          setPagination={setFilter}
          total={totalPages}
        />
      </CardBody>
    </Card>
  );
};

export default withForbiddenWithoutBuyingPackage(DepositAccruals);
